const hiddenClassesBasic = [
  'zonas-de-treino',
  'preparo-mental',
  'nutricao-corredores',
];

export default hiddenClassesBasic;
